var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-menu-wrapper"},[_vm._l((_vm.menus),function(menu){return _c('MenuItem',{key:menu.id,attrs:{"menu":menu}})}),_c('PopupChangePaymentRequisites')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }